import React, { Component } from 'react';
import {Grid, Typography, Button, Card, Paper, TextField, Switch} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
import { ArrowForwardIosRounded, Settings } from '@material-ui/icons';
import DatasheetView from './DatasheetView';
import moment from 'moment';


export default class AssessmentFormPM extends Component {

    constructor(props) {
        super(props);
        
        this.initital_state = {  
            q1_score: false,
            q2_score: false,
            q3_score: false,
            q4_score: false,
            q5_score: false,
            q6_score: false,
            q7_score: false,
            q8_score: false,
            q9_score: false,
            q10_score: false,
            overall_score: 1,
            comment: "",
            has_comment: false,
            writing: false,
            partially_complete: false,
            error: false,
            error_message: '',
            primary_button_enabled: false,
            primary_button_text: 'Submit Assessment',
            selecting_assessor: false,
            show_assessors: false,
            search_name:'',
            search_number: '',
            search_ready:false,
            searching:false,
            assessors_array: [],
            assessor_name: this.props.employee_name,
            assessor_number: this.props.employee_number
        };
        this.state = {  
            q1_score: false,
            q2_score: false,
            q3_score: false,
            q4_score: false,
            q5_score: false,
            q6_score: false,
            q7_score: false,
            q8_score: false,
            q9_score: false,
            q10_score: false,
            overall_score: 1,
            comment: "",
            has_comment: false,
            writing: false,
            partially_complete: false,
            error: false,
            error_message: '',
            primary_button_enabled: false,
            primary_button_text: 'Submit Assessment',
            is_super_admin_override: false,
            selecting_assessor: false,
            show_assessors: false,
            search_name:'',
            search_number: '',
            search_ready:false,
            searching:false,
            assessors_array: [],
            assessor_name: this.props.employee_name,
            assessor_number: this.props.employee_number
        };
        this.pattern = new RegExp("^[a-zA-Z0-9 `'?,.;!]+$");
        this.datasheetFieldSpecs = [
            { field: 'select', headerName: ' ', width: 120, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <Button 
                    onClick={()=>this.updateAssessor(parms)} 
                    color='primary'
                    variant='outlined'
                    disabled={!this.state.search_ready}
                >
                    Select
                    {/* <HowToRegTwoTone/> */}
                </Button>
            )},
            { field: 'name', headerName: 'Employee', width: 180},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'store_code', headerName: 'Store Code', width: 120, sortable:false},
            { field: 'store', headerName: 'Store', width: 160},
            { field: 'region', headerName: 'Region', width: 160},
            { field: 'date_of_entry', headerName: 'DOE', width: 120},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125}
        ]
    }

    componentDidMount = () => {
        //   check whether this is a capture of someone else's assessment by a super_admin
      if ((this.props.assessment.assessment_type_id==="M"&&(this.props.assessment.reports_to_rom!==this.props.rom_code))||(this.props.assessment.requires_nomination&&(this.props.assessment.nominated_assessor_id!==this.props.employee_number))) {
        this.setState({is_super_admin_override:true})
      }
    };

    handleToggleChange = (e,newVal) => {
        let score_total = 0;
        if (this.state.q1_score) {score_total++}
        if (this.state.q2_score) {score_total++}
        if (this.state.q3_score) {score_total++}
        if (this.state.q4_score) {score_total++}
        if (this.state.q5_score) {score_total++}
        if (this.state.q6_score) {score_total++}
        if (this.state.q7_score) {score_total++}
        if (this.state.q8_score) {score_total++}
        if (this.state.q9_score) {score_total++}
        if (this.state.q10_score) {score_total++}

        if (newVal){
            score_total++
        } else {
            score_total--
        }

        // console.log('score_total :>> ', score_total);

        let overall_score = 1;
        if (score_total>3){overall_score++}
        if (score_total>8){overall_score++}
        // console.log('overall_score :>> ', overall_score);

        switch (e.target.id) {
            case "q1":
                this.setState({q1_score:newVal,overall_score:overall_score, partially_complete:true});
                break;

            case "q2":
                this.setState({q2_score:newVal,overall_score:overall_score,partially_complete:true});
                break;

            case "q3":
                this.setState({q3_score:newVal,overall_score:overall_score,partially_complete:true});
                break;
        
            case "q4":
                this.setState({q4_score:newVal,overall_score:overall_score,partially_complete:true});
                break;

            case "q5":
                this.setState({q5_score:newVal,overall_score:overall_score,partially_complete:true});
                break;
        
            case "q6":
                this.setState({q6_score:newVal,overall_score:overall_score,partially_complete:true});
                break;

            case "q7":
                this.setState({q7_score:newVal,overall_score:overall_score,partially_complete:true});
                break;
        
            case "q8":
                this.setState({q8_score:newVal,overall_score:overall_score,partially_complete:true});
                break;

            case "q9":
                this.setState({q9_score:newVal,overall_score:overall_score,partially_complete:true});
                break;

            case "q10":
                this.setState({q10_score:newVal,overall_score:overall_score,partially_complete:true});
                break;
        
            default:
                break;
        }

    }

    handleCommentChange = (e) => {
        // console.log('e.target.value :>> ', e.target.value);
        if (!e.target.value){
            this.setState({comment:"", has_comment:false});
        } else if (this.pattern.test(e.target.value)&&(e.target.value.length<=500)){
            if (e.target.value.length>=1){
                this.setState({comment:e.target.value, partially_complete:true,has_comment:true});
            } else {
                this.setState({comment:e.target.value, partially_complete:true,has_comment:false});
            }
        }
    }
   
    resetMe = () => {
        this.setState(this.initital_state);
        // this.componentDidMount();
    }

    changeAssessor = () => {
        if (this.props.super_admin){
            this.setState({selecting_assessor:true})
        }
    }

    updateAssessor = (parms) => {
        // console.log('parms.row :>> ', parms.row);
        if (this.props.super_admin){
            this.setState({selecting_assessor:false,search_name:'',search_ready:false,searching:false,error:false,error_message:'',show_assessors:false, assessor_name: parms.row.name, assessor_number:parms.row.id})
        }
    }

    runSearch = (e) => {
        e.preventDefault();
        // console.log('e :>> ', e);

        if (!this.state.search_name&&!this.state.search_number){return}

        this.setState({searching:true, search_ready:false});
        Gserv.sendCommand('find_users_for_group_registry',this.props.gwt,{
            search_string: this.state.search_name? this.state.search_name : this.state.search_number,
            search_type: this.state.search_name? 'surname' : 'employee number',
            assessment: this.state.current_record
        })
        .then(reply => {
            // console.log('search reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (find_users_for_group_registry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (find_users_for_group_registry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                //not broken, but for some reason couldn't update / add record
                if (reply.statusCode===204){
                    this.setState({error_message:"No employee records found matching the search."});
                } else {
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."})
                }
            } else {
                if (reply.Records){
                    let record_array = reply.Records;
                    let DOE = null;
                    for (var i=0;i<record_array.length;i++){
                        DOE = new moment(record_array[i].date_of_entry).format("YYYY-MM-DD");
                        record_array[i].date_of_entry = DOE;
                    }
                }
                this.setState({assessors_array:reply.Records,show_assessors:true,searching:false,search_ready:true});

            }
        });

    }

    submitMe = () => {
        this.setState({writing:true});
        const payload = {
            q1_score : this.state.q1_score,
            q2_score : this.state.q2_score,
            q3_score : this.state.q3_score,
            q4_score : this.state.q4_score,
            q5_score : this.state.q5_score,
            q6_score : this.state.q6_score,
            q7_score : this.state.q7_score,
            q8_score : this.state.q8_score,
            q9_score : this.state.q9_score,
            q10_score : this.state.q10_score,
            overall_score : this.state.overall_score,
            comment : this.state.comment,
            assessment : this.props.assessment,
            assessor_employee_number : this.state.assessor_number,
            assessor_not_submitter : this.state.assessor_number !== this.props.employee_number ? true : false
        }
        Gserv.sendCommand('create_pm_assessment',this.props.gwt,payload)
        .then(reply=>{
            if (reply.error){
                console.log('error on return from Gserv (create_pm_assessment) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (create_pm_assessment) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
            } else {
                this.props.resetParentState();             
            }
        });
    }

    render() {
        const assmt = this.props.assessment;
        const addr = assmt.assessment_type_id==="S"? "Do you" : "Does he or she";
        const addr2 = assmt.assessment_type_id==="S"? "yourself" : "him or her";
        const addr3 = assmt.assessment_type_id==="S"? "your" : "his or her";
        const addr4 = assmt.assessment_type_id==="S"? "you" : "he or she";


        return (
            <div>

                {!this.state.writing&&    
                <Paper
                    elevation={3}
                >
                <Grid
                    container
                    direction='column'
                    // justifyContent='center'
                    // alignContent='center'
                    style={{padding:'25px'}}
                >

                    <Typography
                        variant='h5'
                        color='primary'
                        style={{paddingTop:15, textAlign:'left'}}
                    >
                        Potential Meter <b>(PM)</b>
                    </Typography>
                    <Typography
                        style={{textAlign:'left',marginBottom:'5px'}}
                    >
                        Assessment
                    </Typography>     

                    <Typography
                        style={{borderWidth:'1px',borderStyle:'solid',padding:'10px'}}
                    >
                        {assmt.assessment_type} assessment for <b>{assmt.assessee_name}</b> ({assmt.job_title}) for cycle <b>{assmt.cycle_code}</b>
                    </Typography>

                    <br/>

                    <Typography
                        color='primary'
                    >
                        <b><i>Please answer the following questions with respect to {assmt.assessment_type_id==="S"? "your" : assmt.assessee_name + "'s"} potential</i></b>
                    </Typography>

                    {/* <br/> */}   
                    <hr style={{width:'100%'}}/>        

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                            style={{padding:'10px', width:'750px'}}
                        >
                            <Typography
                                style={{textAlign:'left'}}
                            >
                                {addr} demonstrate comfort with a broader company perspective than his or her job currently requires? 
                            </Typography>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Grid
                            container
                            direction='column'
                            justifyContent='center'
                            alignContent='center'
                            style={{width:'50px'}}
                        > 
                            <Switch
                                id="q1"
                                checked={this.state.q1_score}
                                onChange={this.handleToggleChange}
                                color='primary'
                                style={{alignSelf:'center'}}
                            />
                        </Grid>
                        &nbsp;&nbsp;
                        <Typography
                            color={this.state.q1_score? 'primary' : 'initial'}
                            style={{alignSelf:'center',fontSize:30}}
                        >
                            <b>{this.state.q1_score? "YES" : "NO"}</b>
                        </Typography>
                    </Grid>

                    <hr style={{width:'100%'}}/>        

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                            style={{padding:'10px', width:'750px'}}
                        >
                            <Typography
                                style={{textAlign:'left'}}
                            >
                                Can you envision {addr2} performing two levels above {addr3} current position in the next five to six years? 
                            </Typography>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Grid
                            container
                            direction='column'
                            justifyContent='center'
                            alignContent='center'
                            style={{width:'50px'}}
                        > 
                            <Switch
                                id="q2"
                                checked={this.state.q2_score}
                                onChange={this.handleToggleChange}
                                color='primary'
                                style={{alignSelf:'center'}}
                            />
                        </Grid>
                        &nbsp;&nbsp;
                        <Typography
                            color={this.state.q2_score? 'primary' : 'initial'}
                            style={{alignSelf:'center',fontSize:30}}
                        >
                            <b>{this.state.q2_score? "YES" : "NO"}</b>
                        </Typography>
                    </Grid>
                    
                    <hr style={{width:'100%'}}/>  

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                            style={{padding:'10px', width:'750px'}}
                        >
                            <Typography
                                style={{textAlign:'left'}}
                            >
                                Is the organization likely to value growth of {addr3} skills and competencies over the next several years?
                            </Typography>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Grid
                            container
                            direction='column'
                            justifyContent='center'
                            alignContent='center'
                            style={{width:'50px'}}
                        > 
                            <Switch
                                id="q3"
                                checked={this.state.q3_score}
                                onChange={this.handleToggleChange}
                                color='primary'
                                style={{alignSelf:'center'}}
                            />
                        </Grid>
                        &nbsp;&nbsp;
                        <Typography
                            color={this.state.q3_score? 'primary' : 'initial'}
                            style={{alignSelf:'center',fontSize:30}}
                        >
                            <b>{this.state.q3_score? "YES" : "NO"}</b>
                        </Typography>
                    </Grid>
                   
                    <hr style={{width:'100%'}}/>        

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                            style={{padding:'10px', width:'750px'}}
                        >
                            <Typography
                                style={{textAlign:'left'}}
                            >
                                {addr} demonstrate an ability to comfortably interact with people at a higher level or in different areas? 
                            </Typography>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Grid
                            container
                            direction='column'
                            justifyContent='center'
                            alignContent='center'
                            style={{width:'50px'}}
                        > 
                            <Switch
                                id="q4"
                                checked={this.state.q4_score}
                                onChange={this.handleToggleChange}
                                color='primary'
                                style={{alignSelf:'center'}}
                            />
                        </Grid>
                        &nbsp;&nbsp;
                        <Typography
                            color={this.state.q4_score? 'primary' : 'initial'}
                            style={{alignSelf:'center',fontSize:30}}
                        >
                            <b>{this.state.q4_score? "YES" : "NO"}</b>
                        </Typography>
                    </Grid>                    
                   
                    <hr style={{width:'100%'}}/>       

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                            style={{padding:'10px', width:'750px'}}
                        >
                            <Typography
                                style={{textAlign:'left'}}
                            >
                                Could {addr4} perform at a higher level, in a different position or take on increased responsibilities within the next <b>year</b> (consider {addr3} ability only, not whether there is a position available to support this growth)?
                            </Typography>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Grid
                            container
                            direction='column'
                            justifyContent='center'
                            alignContent='center'
                            style={{width:'50px'}}
                        > 
                            <Switch
                                id="q5"
                                checked={this.state.q5_score}
                                onChange={this.handleToggleChange}
                                color='primary'
                                style={{alignSelf:'center'}}
                            />
                        </Grid>
                        &nbsp;&nbsp;
                        <Typography
                            color={this.state.q5_score? 'primary' : 'initial'}
                            style={{alignSelf:'center',fontSize:30}}
                        >
                            <b>{this.state.q5_score? "YES" : "NO"}</b>
                        </Typography>
                    </Grid>                           
                   
                    <hr style={{width:'100%'}}/>

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                            style={{padding:'10px', width:'750px'}}
                        >
                            <Typography
                                style={{textAlign:'left'}}
                            >
                                {addr} welcome opportunities for learning and development? 
                            </Typography>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Grid
                            container
                            direction='column'
                            justifyContent='center'
                            alignContent='center'
                            style={{width:'50px'}}
                        > 
                            <Switch
                                id="q6"
                                checked={this.state.q6_score}
                                onChange={this.handleToggleChange}
                                color='primary'
                                style={{alignSelf:'center'}}
                            />
                        </Grid>
                        &nbsp;&nbsp;
                        <Typography
                            color={this.state.q6_score? 'primary' : 'initial'}
                            style={{alignSelf:'center',fontSize:30}}
                        >
                            <b>{this.state.q6_score? "YES" : "NO"}</b>
                        </Typography>
                    </Grid>         

                    <hr style={{width:'100%'}}/>

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                            style={{padding:'10px', width:'750px'}}
                        >
                            <Typography
                                style={{textAlign:'left'}}
                            >
                                Could {addr4} perform at a higher level, in a different position, or take on increased responsibilities within the next <b>three years</b> (consider {addr3} ability only, not whether there is a position available to support this growth)? 
                            </Typography>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Grid
                            container
                            direction='column'
                            justifyContent='center'
                            alignContent='center'
                            style={{width:'50px'}}
                        > 
                            <Switch
                                id="q7"
                                checked={this.state.q7_score}
                                onChange={this.handleToggleChange}
                                color='primary'
                                style={{alignSelf:'center'}}
                            />
                        </Grid>
                        &nbsp;&nbsp;
                        <Typography
                            color={this.state.q7_score? 'primary' : 'initial'}
                            style={{alignSelf:'center',fontSize:30}}
                        >
                            <b>{this.state.q7_score? "YES" : "NO"}</b>
                        </Typography>
                    </Grid>         

                    <hr style={{width:'100%'}}/>

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                            style={{padding:'10px', width:'750px'}}
                        >
                            <Typography
                                style={{textAlign:'left'}}
                            >
                                {addr} demonstrate leadership ability by showing initiative and vision, delivering on promised results, communicating effectively, and taking appropriate risks?
                            </Typography>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Grid
                            container
                            direction='column'
                            justifyContent='center'
                            alignContent='center'
                            style={{width:'50px'}}
                        > 
                            <Switch
                                id="q8"
                                checked={this.state.q8_score}
                                onChange={this.handleToggleChange}
                                color='primary'
                                style={{alignSelf:'center'}}
                            />
                        </Grid>
                        &nbsp;&nbsp;
                        <Typography
                            color={this.state.q8_score? 'primary' : 'initial'}
                            style={{alignSelf:'center',fontSize:30}}
                        >
                            <b>{this.state.q8_score? "YES" : "NO"}</b>
                        </Typography>
                    </Grid>         

                    <hr style={{width:'100%'}}/>

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                            style={{padding:'10px', width:'750px'}}
                        >
                            <Typography
                                style={{textAlign:'left'}}
                            >
                                Could {addr4} learn the additional skills and competencies {addr4} will need to be able to perform at a higher or different level? 
                            </Typography>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Grid
                            container
                            direction='column'
                            justifyContent='center'
                            alignContent='center'
                            style={{width:'50px'}}
                        > 
                            <Switch
                                id="q9"
                                checked={this.state.q9_score}
                                onChange={this.handleToggleChange}
                                color='primary'
                                style={{alignSelf:'center'}}
                            />
                        </Grid>
                        &nbsp;&nbsp;
                        <Typography
                            color={this.state.q9_score? 'primary' : 'initial'}
                            style={{alignSelf:'center',fontSize:30}}
                        >
                            <b>{this.state.q9_score? "YES" : "NO"}</b>
                        </Typography>
                    </Grid>         

                    <hr style={{width:'100%'}}/>

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                            style={{padding:'10px', width:'750px'}}
                        >
                            <Typography
                                style={{textAlign:'left'}}
                            >
                                {addr} demonstrate flexibility and motivation to move into a new position that might still be developed? 
                            </Typography>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Grid
                            container
                            direction='column'
                            justifyContent='center'
                            alignContent='center'
                            style={{width:'50px'}}
                        > 
                            <Switch
                                id="q10"
                                checked={this.state.q10_score}
                                onChange={this.handleToggleChange}
                                color='primary'
                                style={{alignSelf:'center'}}
                            />
                        </Grid>
                        &nbsp;&nbsp;
                        <Typography
                            color={this.state.q10_score? 'primary' : 'initial'}
                            style={{alignSelf:'center',fontSize:30}}
                        >
                            <b>{this.state.q10_score? "YES" : "NO"}</b>
                        </Typography>
                    </Grid>         

                    <hr style={{width:'100%'}}/>

                    {this.props.admin&&
                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='center'
                        style={{width:'1050px'}}
                    >
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                            style={{padding:'10px', width:'400px'}}
                        >
                            <Typography
                                // variant='h5'
                                style={{textAlign:'left'}}
                            >
                                Overall Potential Score:  
                            </Typography>

                            <Typography
                                color={this.state.overall_score===1? 'secondary' : (this.state.overall_score===2? 'initial' : 'primary')}
                                style={{alignSelf:'center',fontSize:40}}
                            >
                                <b>{this.state.overall_score}</b>
                            </Typography>

                        </Card>
                    </Grid>}

                    {this.props.admin&&    
                    <hr style={{width:'100%'}}/>}

                    <TextField 
                        id={'comment'}
                        type={'text'}
                        fullWidth={true}
                        label={'Comment'}
                        inputProps={{maxLength:500,minLength:10}}
                        autoCapitalize='off'
                        autoComplete='off'
                        autoCorrect='off'
                        required={true}
                        onChange={this.handleCommentChange}
                        value={this.state.comment}
                        disabled={this.writing}
                        variant='standard'
                    />

                    <Grid 
                        container
                        direction='row'
                        style={{marginTop:'15px'}}
                        // justifyContent='center'
                        alignItems='center'
                        
                    >            
                        <Typography style={{textAlign:'left'}}>
                            Assessor: <b>{this.state.assessor_name}</b> [{this.state.assessor_number}] 
                        </Typography>
                        {this.state.is_super_admin_override&&
                            <Button 
                                variant="contained"
                                color='primary'
                                style={{marginLeft:'10px'}}
                                onClick={this.changeAssessor}
                                disabled={this.state.selecting_assessor}
                            >
                                Change
                        </Button>}
                    </Grid>
                    
                    {/* ** Start - Assessor Selection Panel ** */}
                    {this.state.selecting_assessor&&
                    <div>    
                        <hr/>    
                        <Typography
                            color='primary'
                            style={{paddingTop:10}}
                        >
                            Select Assessor
                        </Typography>
                        <Grid
                            container
                            direction='column'
                            justifyContent='space-evenly'
                            alignContent='center'
                            style={{padding:15}}
                        >
    
                            <form onSubmit={this.runSearch}>
                                <TextField
                                    autoComplete="off"
                                    autoCorrect="off"
                                    autoCapitalize="on"
                                    autoFocus={true}
                                    label={'Surname Search'}
                                    variant='outlined'
                                    value={this.state.search_name}
                                    onChange={(e) => {
                                        const outText = e.target.value.replace(/[^ A-Za-z]+/g, '').toUpperCase();
                                        const can_sub = (outText.length>2);
                                        this.setState({search_name: outText, search_number: '', search_ready: can_sub, error: false});
                                    }}
                                    // required
                                    style={{marginBottom:'10px', marginRight:'10px'}}
                                    disabled={this.state.searching}
                                />
                                <TextField
                                    autoComplete="off"
                                    autoCorrect="off"
                                    autoCapitalize="off"
                                    autoFocus={false}
                                    label={'Employee # Search'}
                                    variant='outlined'
                                    value={this.state.search_number}
                                    onChange={(e) => {
                                        const outText = e.target.value.replace(/[^ A-Za-z0-9]+/g, '').toUpperCase();
                                        const can_sub = (outText.length>2);
                                        this.setState({search_number: outText, search_name:"", search_ready: can_sub, error: false});
                                    }}
                                    // required
                                    style={{marginBottom:'10px', marginLeft:'10px'}}
                                    disabled={this.state.searching}
                                />
                                <br/>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    type='submit'
                                    disabled={!this.state.search_ready}
                                >
                                    Search
                                </Button>
                                <Button
                                    variant='contained'
                                    onClick={()=>this.setState({selecting_assessor:false,search_name:'',search_ready:false,searching:false,error:false,error_message:'',show_assessors:false, assessor_name: this.props.employee_name, assessor_number:this.props.employee_number})}
                                    style={{marginLeft:'10px'}}
                                    // color='primary'
                                    // type='submit'
                                >
                                    I'm the Assessor
                                </Button>
                                <Button
                                    variant='contained'
                                    onClick={()=>this.setState({selecting_assessor:false,search_name:'',search_number:'',search_ready:false,searching:false,error:false,error_message:'',show_assessors:false})}
                                    style={{marginLeft:'10px'}}
                                    // color='primary'
                                    // type='submit'
                                >
                                    Back
                                </Button>
                            </form>
                        </Grid>
                    </div>}
    
                    {this.state.show_assessors&&
                    <DatasheetView
                        dataset={this.state.assessors_array}
                        fieldspecs={this.datasheetFieldSpecs}
                        delete={false}
                        edit={false}
                        handleDelete={null}
                        handleEdit={null}
                        loading={this.state.searching}
                        deleteHeaderName={'Delete'}
                        height={350}
                    />}
                    {/* **End Assessor Selection Panel */}                    

                    <Grid item>
                        <Typography color='secondary' style={{Width:1200,maxWidth:1200, textAlign:'center'}}>{this.state.error_message}</Typography>
                        {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                    </Grid>

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='center'
                        style={{width:'1050px'}}
                    >
                        <Button 
                            type='button'
                            variant='outlined'
                            disabled={this.state.writing}
                            onClick={this.props.returnToParent}
                            style={{marginTop:'20px',marginBottom:'10px'}}
                        >
                            Cancel
                        </Button>
                        <Button 
                            type='button'
                            variant='outlined'
                            disabled={!this.state.partially_complete}
                            onClick={this.resetMe}
                            style={{marginTop:'20px',marginBottom:'10px'}}
                        >
                            Reset
                        </Button>
                        <Button 
                            color='primary'
                            variant='contained'
                            disabled={!(this.state.has_comment)||this.state.writing}
                            style={{marginTop:'20px',marginBottom:'10px'}}
                            onClick={this.submitMe}
                        >
                            {this.state.primary_button_text}
                        </Button>
                    </Grid>
                </Grid>
                </Paper>}

                {this.state.writing&&            
                <div className='pageContainer' style={{minHeight:'70vh'}}>
                <div>
                    <Settings className='icn-spinner' /> Submitting...
                </div>
                </div>}

                <br/><br/>
            </div>
        );
    }
    
}